import { Box, CloseButton, Flex, Heading, HStack } from '@chakra-ui/react';

import { E_LOGO_TYPES, RepublicLogo } from '@r-client/republic/feature/brand';

import { ProfileMenu } from '../profile-menu/profile-menu';

export interface ISideBarHeaderProps {
  collapsed?: boolean;
  appLastUpdated?: string;
  appReleaseVersion?: string;
  onClose?: () => void;
}

export const SideBarHeader = ({
  collapsed,
  appLastUpdated,
  appReleaseVersion,
  onClose,
}: ISideBarHeaderProps) => (
  <Flex
    py={4}
    alignItems="center"
    mx={!collapsed ? 0 : 4}
    justifyContent={!collapsed ? 'space-between' : 'center'}
    width={!collapsed ? '100%' : 'auto'}
    minH={14}
    px={2}
  >
    <HStack alignItems="center" spacing={4}>
      <RepublicLogo type={E_LOGO_TYPES.RLogoSmall} />
      {!collapsed && <Heading size="admin-h4">Republic</Heading>}
    </HStack>
    <Box display="flex">
      {!collapsed && (
        <ProfileMenu
          appLastUpdated={appLastUpdated}
          appReleaseVersion={appReleaseVersion}
        />
      )}
      <CloseButton
        display={{ base: 'flex', md: 'none' }}
        ml={3}
        onClick={onClose}
      />
    </Box>
  </Flex>
);
